var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.isIframe
    ? _c(
        "v-app-bar",
        { attrs: { app: "" } },
        [
          _c("h1", [_vm._v(_vm._s(_vm.accountname))]),
          _c("v-spacer"),
          _c("locale-switcher"),
          _vm.$store.getters.currentUserProfile
            ? _c(
                "v-menu",
                {
                  attrs: { "offset-y": "" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "activator",
                        fn: function(ref) {
                          var on = ref.on
                          var attrs = ref.attrs
                          return [
                            _c(
                              "v-btn",
                              _vm._g(
                                _vm._b(
                                  { attrs: { color: "blue" } },
                                  "v-btn",
                                  attrs,
                                  false
                                ),
                                on
                              ),
                              [
                                _c(
                                  "v-icon",
                                  {
                                    staticClass: "mr-2",
                                    attrs: { color: "white" }
                                  },
                                  [_vm._v(" mdi-account-circle ")]
                                ),
                                _vm._v(_vm._s(_vm.displayName) + " ")
                              ],
                              1
                            )
                          ]
                        }
                      }
                    ],
                    null,
                    false,
                    1089972282
                  )
                },
                [_c("user-profile-selection", { attrs: { mini: "" } })],
                1
              )
            : _vm._e(),
          _c(
            "div",
            { staticClass: "popups" },
            [
              _c(
                "notification-alert",
                _vm._b(
                  {
                    on: {
                      closed: function($event) {
                        return _vm.closeModal()
                      }
                    }
                  },
                  "notification-alert",
                  _vm.teamWork,
                  false
                )
              )
            ],
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }